import { CartItem, Portfolio } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { makeAutoObservable } from 'mobx';
import { INITIAL_CART_ITEM, INITIAL_PORTFOLIO, PortfolioToCartItem } from 'store/modules/proposal/types';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';

interface DomainParams {
  enrollmentPeriodId: string;
  cartId: string;
  groupId: string;
  productLineId: ProductLineId;
}

interface DomainData {
  portfolioToCartItem: PortfolioToCartItem;
  domainParams: DomainParams;
  onOverrideRates: (params: OverrideRatesRedirectParams) => void;
}

export interface OverrideRatesRedirectParams {
  groupId: string;
  enrollmentPeriodId: string;
  cartId: string;
  portfolioId: string;
  productLineId: ProductLineId;
  bcIndex: number;
}

export default class CartItemDelegate {
  private _portfolio: Portfolio = { ...INITIAL_PORTFOLIO };
  private _cartItem: CartItem = { ...INITIAL_CART_ITEM };
  private _domainParams: DomainParams;
  private _onOverrideRates: (params: OverrideRatesRedirectParams) => void;

  public get portfolioId(): string {
    return this._portfolio.id;
  }

  public get wholePortfolio(): Portfolio {
    return this._portfolio;
  }

  public get wholeCartItem(): CartItem {
    return this._cartItem;
  }

  /**
   * Sets browsing criteria for a specific portfolio
   * @param selectedBcIndex - The selected browsing criteria index
   */
  public setBrowsingCriteria(_: string, selectedBcIndex: number): void {
    this._cartItem.selectedIndex = selectedBcIndex;
  }

  public redirectToOverrideRatesPage(portfolioId: string, bcIndex: number): void {
    this._onOverrideRates({ ...this._domainParams, portfolioId, bcIndex });
  }

  constructor({ portfolioToCartItem, domainParams, onOverrideRates }: DomainData) {
    this._portfolio = portfolioToCartItem.portfolio;
    this._cartItem = portfolioToCartItem.cartItem;
    this._domainParams = domainParams;
    this._onOverrideRates = onOverrideRates;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
